<div class="process-execution-status-container">
	<div class="process-execution-status-item" *ngFor="let step of steps">
		<span>
			<i class="process-execution-status-fa"
			   [ngClass]="step.status == ProcessStepStatusEnum.NotStarted ? 'far fa-circle' :
						  step.status == ProcessStepStatusEnum.InProgress ? 'fas fa-circle-notch fa-spin process-execution-status-fa-spin' :
						  'fas fa-check process-execution-status-fa-check'"></i>
			{{step.name}}
		</span>
	</div>
</div>